module.exports = __webpack_public_path__ + "assets/img/fomede_LIBER_panqueca.d813ac5d.png";